<template>
  <div>
    <q-dialog :visible="isVisible" :title="'商品编辑记录'" width="1100px" :innerScroll="false" :showFooter="false" :loading="loadingBtn" @close="onCancel">
      <div class="content">
        <div class="description-text">此处仅统计"已发布"上市清单的商品编辑记录</div>
        <search-box-dialog class="search-box">
          <el-form :inline="true" size="mini" :model="searchForm" :rules="rules" ref="searchForm">
            <el-form-item label="商品编码:">
              <el-input v-model="searchForm.skuCode" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="商品名称:">
              <el-input v-model.trim="searchForm.goodsName" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="编辑时间:">
              <form-date-range :form="searchForm" startKey="dts" endKey="dte" :usingTime="false" valueFormat="yyyy-MM-dd"></form-date-range>
            </el-form-item>
          </el-form>
          <template v-slot:right>
            <el-button class="green-btn" size="mini" @click="onSearch">查询</el-button>
            <el-button class="orange-btn" size="mini" @click="onReset">重置</el-button>
          </template>
        </search-box-dialog>

        <el-table
          ref="table"
          v-loading="loading"
          element-loading-text="数据加载中"
          element-loading-spinner="el-icon-loading"
          :header-cell-style="{ backgroundColor: '#F4F8FB' }"
          :data="tableData.list"
          :height="260"
          class="full-width-table"
          border
        >
          <el-table-column label="商品编码" prop="skuCode" show-overflow-tooltip width="120"></el-table-column>
          <el-table-column label="商品名称" prop="skuName" show-overflow-tooltip width="180"></el-table-column>
          <el-table-column label="变更记录" prop="content" show-overflow-tooltip></el-table-column>
          <el-table-column label="涉及自动下架店铺" prop="downStoreName" show-overflow-tooltip width="180"></el-table-column>
          <el-table-column label="操作人" prop="userName" show-overflow-tooltip width="100"></el-table-column>
          <el-table-column label="编辑时间" prop="creationDate" show-overflow-tooltip width="160"></el-table-column>
        </el-table>

        <div class="pagination-container" height="auto">
          <el-pagination
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
            :current-page="tableData.pageNum"
            :page-sizes="[10, 30, 50, 100]"
            :page-size="tableData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </div>
      </div>
      <div class="footer-btn">
        <el-button size="mini" @click="onCancel">关闭</el-button>
      </div>
    </q-dialog>
  </div>
</template>

<script>
import searchBoxDialog from '../../components/search-box.vue';
export default {
  name: 'ProductEditRecord',
  components: {
    searchBoxDialog,
  },
  props: {
    // 重新对外暴露visible，控制显示隐藏
    visible: {
      type: Boolean,
      default: false,
    },
    listNo: [String, Number],
  },
  computed: {
    // 通过计算属性，对.sync进行转换，外部也可以直接使用visible.sync
    isVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      },
    },
  },
  data() {
    return {
      loading: false,
      loadingBtn: false,
      rules: {},
      searchForm: {
        skuCode: '',
        goodsName: '',
        dts: '',
        dte: '',
      },
      tableData: {
        list: [],
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
    };
  },
  methods: {
    onCancel() {
      this.isVisible = false;
    },
    onSearch() {
      this.tableData.pageNum = 1;
      this.init();
    },
    init() {
      this.loading = true;
      let data = {
        filterData: {
          listNo: this.listNo,
          ...this.searchForm,
        },
        pageNum: this.tableData.pageNum,
        pageSize: this.tableData.pageSize,
      };
      this.$q.newProduct
        .productListLogs({ data: data })
        .then((res) => {
            this.tableData = res.data
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onReset() {
      this.searchForm.filterData = {
        productCode: '',
        productName: '',
        dts: '',
        dte: '',
      };
      this.tableData.pageNum = 1;
      this.init();
    },
    handleCurrentChange(val) {
      this.tableData.pageNum = val;
      this.init();
    },
    handleSizeChange(val) {
      this.tableData.pageSize = val;
      this.tableData.pageNum = 1;
      this.init();
    },
  },
  created() {
    this.init();
  },
};
</script>

<style lang="stylus" scoped>
.content {
  padding: 0 15px;
  max-height: 70vh;
  overflow-y: auto;
}

.description-text {
  margin: 10px 0;
  font-size: 14px;
  color: #666;
}

.search-box {
  margin-bottom: 15px;
}

>>> .date-range .single-date {
  width: 110px !important;
}

.full-width-table {
  width: 100%;
}

.pagination-container {
  text-align: right;
  padding: 15px 0;
}

.footer-btn {
  text-align: center;
  margin-top: 10px;
}

>>> .dialog-content {
  padding-right: 0 !important;
}

>>> .el-dialog {
  margin-top: 50px !important;
}

::-webkit-scrollbar {
  width: 6px;
}

::-webkit-scrollbar-thumb {
  height: 45.7326%;
  transform: translateY(0%);
  position: relative;
  display: block;
  cursor: pointer;
  border-radius: inherit;
  border-radius: 10px;
  background-color: rgba(144, 147, 153, 0.3);
  transition: 0.3s background-color;
}
</style>
